/*
  Template:
    <inventory-adjustment-editor #adjustmentInlineEditor
      [inventory]="InventorySource"
      [OnHandLabel]="data.inventory.isLotSerItem ? 'Roll Balance' : 'On Hand'"
      [focusInput]="true">
    </inventory-adjustment-editor>

  Script:
    @ViewChild('adjustmentInlineEditor') adjustmentInlineEditor!: InventoryAdjustmentEditorComponent;
*/

import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { InventorySource } from 'src/app/acumatica/EntityServices/OrderPicking.service';

@Component({
  selector: 'inventory-adjustment-editor[inventory]',
  templateUrl: './inventory-adjustment-editor.component.html',
  styleUrls: ['./inventory-adjustment-editor.component.css']
})
export class InventoryAdjustmentEditorComponent implements OnInit {

  @Input() inventory!: InventorySource;
  @Input() focusInput?: boolean;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() OnHandLabel: string = 'Available';

  @Output() onEnterKey = new EventEmitter();
  @Output() OnUpdated = new EventEmitter<void>();

  onAdjustToQtyBlur() {
    let adjustToQty = this.inventory.stockItem.roundQty(this.adjustRemainderTo);
    if (adjustToQty === undefined) adjustToQty = null;
    this.inventory.AdjustRemainderTo = this.adjustRemainingOnHandInput.nativeElement.value = adjustToQty;
    this.adjustRemainderTo = this.inventory.AdjustRemainderTo?.toString() || null;
  }

  private _adjustRemainderTo: string | null = null;
  get adjustRemainderTo(): string | null {
    return this._adjustRemainderTo;
  }
  set adjustRemainderTo(value: string | null) {
    if (typeof value == 'string') {
      if (value == '.') value = '0.';
      if (isNaN(parseFloat(value))) value = '';
    }
    this._adjustRemainderTo = value;
  }

  /** return the Adjustment to make to the original inventory object */
  public get adjustmentAmount(): number | undefined {
    if (this.inventory.AdjustRemainderTo === null) return undefined;
    return this.inventory.stockItem.roundQty(this.inventory.AdjustmentAmt) || 0;
  }

  @ViewChild('adjustRemainingOnHandInput') adjustRemainingOnHandInput!: ElementRef<any>;

  constructor() { }

  ngOnInit() {
    // console.warn(this.inventory);

    if (this.focusInput) setTimeout(() => {
      this.adjustRemainingOnHandInput.nativeElement.focus();
    });

    this.adjustRemainderTo = this.inventory.AdjustRemainderTo?.toString() || null;

    // such as the Pick Detail editor setting the Adjust To Qty to zero when enabling EOR slider
    let _isUpdating: boolean = false
    this.inventory.OnAdjustmentQtyChanged.subscribe(() => {
      if (_isUpdating) return;
      _isUpdating = true;
      this.adjustRemainderTo = this.inventory.AdjustRemainderTo?.toString() || null;
      _isUpdating = false;
    })

  }

  focus() { this.adjustRemainingOnHandInput.nativeElement.focus(); }
}
